import * as React from 'react';
import Preloader from './learning-pathway-collection/partials/Preloader';
import Layout from './learning-pathway-collection/partials/Layout';
import EmptyPlaceholder from './learning-pathway-collection/partials/EmptyPlaceholder';
import ExtraResources from './learning-pathway-collection/partials/ExtraResources';
import FailedPlaceholder from './learning-pathway-collection/partials/FailedPlaceholder';
import Header from './learning-pathway-collection/partials/Header';
import { Config } from './learning-pathway-collection/helper';
import { useCollection } from './learning-pathway-collection/hook';

export default function LearningPathwayCollection(props) {
  const {
    collectionID,
    settings = {},
  } = props;

  const {extraResources = {}} = settings;

  const { state, pathways, scores, progress } = useCollection(collectionID);

  const isLoaded = state === Config.State.loaded;

  return (
    <div className='nv-learning-pathway-collection'>
      <Header
        title={settings.title}
        icon={settings.icon}
        text={settings.description}
        progress={progress}
        breadcrumbs={settings.breadcrumbs}
        extraResources={<ExtraResources label={extraResources.label} items={extraResources.items}/>}
      />

      {state === Config.State.initial && <Preloader/>}
      {state === Config.State.failed && <FailedPlaceholder/>}
      {isLoaded && pathways.length > 0 && <Layout scores={scores} pathways={pathways}/>}
      {isLoaded && pathways.length === 0 && <EmptyPlaceholder/>}
    </div>
  );
}
